export default "__VITE_ASSET__BaSr8QkJ__"